// Helpers
import colors from 'vuetify/es5/util/colors'

const configs = {
  keeponrockin: {
    cloudFn: 'https://us-central1-keeponrockin-db.cloudfunctions.net/api',
    localCloudFn: 'http://localhost:5001/keeponrockin-db/us-central1/api',
    firebaseConfig: {
      apiKey: 'AIzaSyBiKUDyPcp7fC6XE_i_nbD2hAlOFo3oTEs',
      authDomain: 'keeponrockin-db.firebaseapp.com',
      databaseURL: 'keeponrockin-db.firebaseio.com',
      storageBucket: 'gs://keeponrockin-db.appspot.com'
    },
    teamSize: 1,
    title: 'keep on rockin\'',
    contact: {
      name: '@keeponrockin_db',
      url: 'https://twitter.com/keeponrockin_db'
    },
    itemsPerPage: 50,
    dark: true,
    lightPrimary: true,
    theme: {
      primary: colors.green.accent3,
      secondary: colors.green.accent3,
      accent: colors.orange.base,
      error: colors.red.accent2,
      info: colors.blue.base,
      success: colors.green.base,
      warning: colors.amber.base
    }
  },
  testkeeponrockin: {
    cloudFn: 'https://us-central1-test-keeponrockin.cloudfunctions.net/api',
    localCloudFn: 'http://localhost:5001/test-keeponrockin/us-central1/api',
    firebaseConfig: {
      apiKey: 'AIzaSyCNNSup2j-2J52WD50dap_ahfoC5ebLT-s',
      authDomain: 'test-keeponrockin.firebaseapp.com',
      databaseURL: 'test-keeponrockin.firebaseio.com',
      storageBucket: 'gs://test-keeponrockin.appspot.com'
    },
    teamSize: 1,
    title: 'The Wheel of Fate is Turning',
    contact: {
      name: '@keeponrockin_db',
      url: 'https://twitter.com/keeponrockin_db'
    },
    itemsPerPage: 50,
    dark: false,
    lightPrimary: false,
    theme: {
      primary: colors.cyan.lighten2,
      secondary: colors.cyan.lighten2,
      accent: colors.orange.base,
      error: colors.red.accent2,
      info: colors.blue.base,
      success: colors.green.base,
      warning: colors.amber.base
    }
  },
  undernight: {
    cloudFn: 'https://us-central1-undernight-db.cloudfunctions.net/api',
    localCloudFn: 'http://localhost:5001/undernight-db/us-central1/api',
    firebaseConfig: {
      apiKey: 'AIzaSyCWNHmUJaGL12h5QS8qYdL3GczrtqiBL3g',
      authDomain: 'undernight-db.firebaseapp.com',
      databaseURL: 'undernight-db.firebaseio.com',
      storageBucket: 'gs://undernight-db.appspot.com'
    },
    teamSize: 1,
    title: 'PASSING LINK',
    contact: {
      name: '@keeponrockin_db',
      url: 'https://twitter.com/keeponrockin_db'
    },
    itemsPerPage: 50,
    dark: true,
    lightPrimary: false,
    theme: {
      primary: colors.deepPurple.base,
      secondary: colors.red.base,
      accent: colors.blue.accent1,
      error: colors.red.accent2,
      info: colors.blue.base,
      success: colors.green.base,
      warning: colors.amber.base
    }
  },
  blazblue: {
    cloudFn: 'https://us-central1-blazblue-db.cloudfunctions.net/api',
    localCloudFn: 'http://localhost:5001/blazblue-db/us-central1/api',
    firebaseConfig: {
      apiKey: 'AIzaSyAlA7t_Kn3DzxxGV-hbQ_P_VflrZgPv_6o',
      authDomain: 'blazblue-db.firebaseapp.com',
      databaseURL: 'blazblue-db.firebaseio.com',
      storageBucket: 'gs://blazblue-db.appspot.com'
    },
    teamSize: 1,
    title: 'The Wheel of Fate is Turning',
    contact: {
      name: '@keeponrockin_db',
      url: 'https://twitter.com/keeponrockin_db'
    },
    itemsPerPage: 50,
    dark: false,
    lightPrimary: false,
    theme: {
      primary: colors.cyan.lighten2,
      secondary: colors.cyan.lighten2,
      accent: colors.orange.base,
      error: colors.red.accent2,
      info: colors.blue.base,
      success: colors.green.base,
      warning: colors.amber.base
    }
  },
  bbtag: {
    cloudFn: 'https://us-central1-bbtag-db.cloudfunctions.net/api',
    localCloudFn: 'http://localhost:5001/bbtag-db/us-central1/api',
    firebaseConfig: {
      apiKey: 'AIzaSyCIWFMQ3yfGoyO_Z2RFzu8TWFyaxr3ZLnA',
      authDomain: 'bbtag-db.firebaseapp.com',
      databaseURL: 'bbtag-db.firebaseio.com',
      storageBucket: 'gs://bbtag-db.appspot.com'
    },
    teamSize: 2,
    title: 'Can\'t Escape From Crossing Fate',
    contact: {
      name: '@keeponrockin_db',
      url: 'https://twitter.com/keeponrockin_db'
    },
    itemsPerPage: 50,
    dark: false,
    lightPrimary: true,
    theme: {
      primary: colors.lightBlue.accent3,
      secondary: colors.yellow.darken1,
      accent: colors.orange.base,
      error: colors.red.accent2,
      info: colors.blue.base,
      success: colors.green.base,
      warning: colors.amber.base
    }
  },
  granblue: {
    cloudFn: 'https://us-central1-granblue-db.cloudfunctions.net/api',
    localCloudFn: 'http://localhost:5001/granblue-db/us-central1/api',
    firebaseConfig: {
      apiKey: 'AIzaSyAPcRv6OCaJKx5AAshOTn61T3NhmkerOZg',
      authDomain: 'granblue-db.firebaseapp.com',
      databaseURL: 'granblue-db.firebaseio.com',
      storageBucket: 'gs://granblue-db.appspot.com'
    },
    teamSize: 1,
    title: 'Believe in Victory',
    contact: {
      name: '@keeponrockin_db',
      url: 'https://twitter.com/keeponrockin_db'
    },
    itemsPerPage: 50,
    dark: false,
    lightPrimary: false,
    theme: {
      primary: colors.cyan.darken2,
      secondary: colors.cyan.darken2,
      accent: colors.orange.base,
      error: colors.red.accent2,
      info: colors.blue.base,
      success: colors.green.base,
      warning: colors.amber.base
    }
  },
  strive: {
    cloudFn: 'https://us-central1-strive-db.cloudfunctions.net/api',
    localCloudFn: 'http://localhost:5001/strive-db/us-central1/api',
    firebaseConfig: {
      apiKey: 'AIzaSyB5Yf0Y94VwrWoSi4xz8mi24_ZfL5xJL38',
      authDomain: 'strive-db.firebaseapp.com',
      databaseURL: 'strive-db.firebaseio.com',
      storageBucket: 'gs://strive-db.appspot.com'
    },
    teamSize: 1,
    title: 'Still my heart is blazing!',
    contact: {
      name: '@keeponrockin_db',
      url: 'https://twitter.com/keeponrockin_db'
    },
    itemsPerPage: 50,
    dark: false,
    lightPrimary: false,
    theme: {
      primary: colors.red.darken1,
      secondary: colors.red.darken1,
      accent: colors.blueGrey.darken1,
      error: colors.red.accent2,
      info: colors.blue.base,
      success: colors.green.base,
      warning: colors.amber.base
    }
  }
}

export default configs.undernight
